import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

Vue.use(Vuex);

const state = {
  userInfo: {},
  accountInfo: {},
  invoicingInfo: {},
  user: null,
  req: {},
  oldReq: {},
  lastSnapshots: {},
  nextSnapshots: {},  
  invoices: {},
  activeSessions: {},
  inactiveSessions: {},
  activeSessionHandle: '',
  clipboard: {
    key: '',
    items: []
  },
  jwt: '',
  progress: 0,
  loading: false,
  reload: false,
  selected: [],
  multiple: false,
  show: null,
  showShell: false,
  showMessage: null,
  showConfirm: null,
  showData: null,
  sortOrder: 1,
  isMenu: false,
  isDelete: false,
  isRename: false,
  referrerCode: '',
  isCodeVisible: true,
  handleRecord: null,
  handleArchivo: null,
  idCoupon: null,
  emailCoupon: '',
  parentHandle: null,
  accountHandle: null,
  joinLink: '',
  isPreview: false,
  accountHandleJoin: null,
  accountKeyJoin: null,
  registrationId: null,
  createAccountCoupon: '',
  linkInbox: '',
  handleOpenSpace: '',
  isPrompt: false,
  isFaldon: false,
  permissions: 0,
  permissionsSharedDrive: 0,
  linkSharedDrive: '',
  handleSharedDrive: '',
  searchVal: '',
  filterTag: -1,
  isItemOptions: false,
  isMultiSelectedCheck: false,
  // Bloquea los watchers de $route/reload en Cloud.vue mientras un editor
  // interno (SheetEditor/DocsEditor) está guardando, para evitar que el
  // cambio de handle o el listener del SDK provoquen un desmontaje del editor.
  editorSaving: false
};

export default new Vuex.Store({
  strict: true,
  state,
  getters,
  mutations,
  actions
});
